import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsSlotComponent } from '@shared/models';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'ui-slot',
  templateUrl: './slot.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SlotComponent implements OnInit {
  positionName$: Observable<string>;

  constructor(public component: CmsComponentData<CmsSlotComponent>) {}

  ngOnInit(): void {
    this.positionName$ = this.component.data$.pipe(map((data) => data.positionName));
  }
}
